import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { auth } from "./firebaseConfig";
import { onAuthStateChanged } from "firebase/auth";
import Login from "./pages/Login";
import Register from "./pages/Register";
import TipoComprobante from "./pages/TipoComprobante";
import HeaderForm from "./pages/HeaderForm";
import Percepciones from "./pages/Percepciones";
import CuentaCorriente from "./pages/CuentaCorriente";
import Confirmation from "./pages/Confirmation";
import Sidebar from "./Sidebar";
import "./App.css";
import GestionProveedoresHome from "./pages/GestionProveedoresHome";
import InformacionPersonal from "./pages/InformacionPersonal";
import Documentacion from "./pages/Documentacion";
import DocumentacionCarga from "./pages/DocumentacionCarga";
import ReemplazoDocumento from "./pages/ReemplazoDocumento";

function AppContent() {
  const [user, setUser] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);

  // Detectamos si estamos en Login o Register
  const isAuthPage = location.pathname === "/" || location.pathname === "/register";

  return (
    <div className={isAuthPage ? "" : "app-container"}>
      {!isAuthPage && user && <Sidebar />}
      <div className="main-content">
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/home" element={<div className="home-container"><img src="sinec_logo.png" alt="Logo" className="home-logo" /><h1 className="home-title">Bienvenido</h1></div>} />
          <Route path="/tipo-comprobante" element={user ? <TipoComprobante /> : <Navigate to="/" />} />
          <Route path="/header" element={user ? <HeaderForm /> : <Navigate to="/" />} />
          <Route path="/percepciones" element={user ? <Percepciones /> : <Navigate to="/" />} />
          <Route path="/confirm" element={user ? <Confirmation /> : <Navigate to="/" />} />
          <Route path="/cuenta-corriente" element={user ? <CuentaCorriente /> : <Navigate to="/" />} />
          <Route path="/gestionproveedoreshome" element={user ? <GestionProveedoresHome /> : <Navigate to="/" />} />
          <Route path="/informacion-personal" element={user ? <InformacionPersonal /> : <Navigate to="/" />} />
          <Route path="/documentacion" element={user ? <Documentacion /> : <Navigate to="/" />} />
          <Route path="/documentacioncarga" element={user ? <DocumentacionCarga /> : <Navigate to="/" />} />
          <Route path="/reemplazo-documento" element={user ? <ReemplazoDocumento /> : <Navigate to="/" />} />
        </Routes>
      </div>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter> 
      <AppContent />
    </BrowserRouter>
  );
}

export default App;

